import { singleSelectionOptions } from 'src/components/helpers';

export const crecimiento_directores_evaluacion_questions = (inputs = {}) => [
  {
    type: 'title',
    text: 'Medición de Crecimiento – Directores de área (Valores Comunidad MDE)',
    class: 'section-title',
  },
  {
    type: 'richText',
    text: 'Hola 👋\n\nEste instrumento está diseñado para **directores y responsables de área** con el propósito de conocer cómo está creciendo tu área en los valores de **amor, presencia, excelencia y amabilidad**, e identificar avances y retos.',
    class: 'intro-text',
    textOnlyInQuestions: true,
  },
  {
    type: 'title',
    text: '¿Cómo completar la evaluación?',
    class: 'section-subtitle',
    textOnlyInQuestions: true,
  },
  {
    type: 'richText',
    text:
      'Encontrarás afirmaciones para marcar **cuánto estás de acuerdo** usando la siguiente escala:\n\n' +
      '**1 Totalmente en desacuerdo**\n' +
      '**2 En desacuerdo**\n' +
      '**3 Ni de acuerdo ni en desacuerdo**\n' +
      '**4 De acuerdo**\n' +
      '**5 Totalmente de acuerdo**\n\n' +
      'Al final de cada sección encontrarás **preguntas abiertas** (opcionales, pero muy útiles).',
    class: 'intro-instructions',
    textOnlyInQuestions: true,
  },
  {
    type: 'text',
    text: 'Completarla te tomará aproximadamente 8–12 minutos.',
    class: 'intro-text',
    textOnlyInQuestions: true,
  },

  // SECTION 0
  {
    type: 'title',
    text: 'SECCIÓN 0 – Datos generales',
    class: 'section-title',
  },
  {
    type: 'select',
    id: 'area_equipo',
    text: 'Área / equipo:',
    options: [
      'Comunicaciones',
      'Producción',
      'Music',
      'Experiencia',
      'Generaciones',
      'Administración / Contabilidad',
      'Fundación',
      'Otra',
    ],
  },
  {
    type: 'input',
    id: 'area_equipo_otra',
    text: 'Si seleccionaste "Otra", especifica:',
    kind: 'text',
    notMandatory: inputs.area_equipo !== 'Otra',
  },

  // SECTION 1 – AMOR
  {
    type: 'title',
    text: 'SECCIÓN 1 – Valor AMOR',
    class: 'section-title',
  },
  {
    type: 'richText',
    text: '**Propósito:** Ver cómo el área cuida a las personas, se relaciona y vive el amor en lo práctico.',
    class: 'intro-text',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones sobre tu área:',
  },
  {
    type: 'select',
    id: 'q1',
    text: '1. En mi área es habitual que las personas se interesen genuinamente por la vida y el bienestar de los demás.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q2',
    text: '2. Cuando alguien atraviesa una situación difícil, el equipo busca rodearlo y apoyarlo de manera concreta.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q3',
    text: '3. En mi área se manejan las diferencias y los desacuerdos sin atacar a la persona, sino cuidando la relación.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q4',
    text: '4. Como director/a, procuro conocer y acompañar a las personas de mi área más allá de las tareas que realizan.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q5',
    text: '5. En mi área se celebra y reconoce el aporte de las personas, no solo el resultado.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q6',
    text: '6. ¿En qué ves que tu área ha crecido recientemente en el valor de AMOR?',
  },
  {
    type: 'textArea',
    id: 'q7',
    text: '7. ¿Qué te gustaría fortalecer en tu área para vivir aún más el valor de AMOR?',
  },

  // SECTION 2 – PRESENCIA
  {
    type: 'title',
    text: 'SECCIÓN 2 – Valor PRESENCIA',
    class: 'section-title',
  },
  {
    type: 'richText',
    text: '**Propósito:** Ver cuánto el área cuida la dimensión espiritual y la dependencia del Espíritu Santo.',
    class: 'intro-text',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones sobre tu área:',
  },
  {
    type: 'select',
    id: 'q8',
    text: '8. En mi área hay conciencia de que lo que hacemos depende del Espíritu Santo, no solo de nuestra capacidad.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q9',
    text: '9. Es habitual que en mi área tomemos espacios (aunque sean breves) para orar o buscar al Señor antes de decisiones importantes o momentos clave.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q10',
    text: '10. Las personas de mi área entienden que su servicio también es una forma de adorar y honrar a Dios.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q11',
    text: '11. Como director/a, procuro modelar una vida que busca la presencia de Dios y lo transmito en la forma en que lidero el área.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q12',
    text: '12. En mi área se habla de la importancia de crecer en la relación personal con Dios, no solo en habilidades técnicas.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q13',
    text: '13. ¿En qué ves que tu área ha crecido recientemente en el valor de PRESENCIA?',
  },
  {
    type: 'textArea',
    id: 'q14',
    text: '14. ¿Qué prácticas concretas te gustaría incorporar o fortalecer para que tu área viva más el valor de PRESENCIA?',
  },

  // SECTION 3 – EXCELENCIA
  {
    type: 'title',
    text: 'SECCIÓN 3 – Valor EXCELENCIA',
    class: 'section-title',
  },
  {
    type: 'richText',
    text: '**Propósito:** Ver cómo el área cuida la calidad, la claridad y la responsabilidad en lo que hace.',
    class: 'intro-text',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones sobre tu área:',
  },
  {
    type: 'select',
    id: 'q15',
    text: '15. En mi área hay claridad sobre los objetivos y resultados esperados de lo que hacemos.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q16',
    text: '16. Procuramos planear con anticipación y no dejar las cosas solo para última hora.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q17',
    text: '17. En mi área se busca continuamente mejorar procesos, detalles y resultados, no conformarse con “como siempre se ha hecho”.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q18',
    text: '18. Las personas de mi área responden con responsabilidad frente a los compromisos que asumen.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q19',
    text: '19. En mi área existe apertura para recibir retroalimentación y hacer ajustes cuando algo no salió bien.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q20',
    text: '20. ¿En qué ves que tu área ha crecido recientemente en el valor de EXCELENCIA?',
  },
  {
    type: 'textArea',
    id: 'q21',
    text: '21. ¿Qué te gustaría mejorar en tu área para reflejar mejor el valor de EXCELENCIA?',
  },

  // SECTION 4 – AMABILIDAD
  {
    type: 'title',
    text: 'SECCIÓN 4 – Valor AMABILIDAD',
    class: 'section-title',
  },
  {
    type: 'richText',
    text: '**Propósito:** Ver cómo el área refleja amabilidad, trato respetuoso y ambiente sano en las interacciones.',
    class: 'intro-text',
  },
  {
    type: 'text',
    text: 'Marca tu nivel de acuerdo con las siguientes afirmaciones sobre tu área:',
  },
  {
    type: 'select',
    id: 'q22',
    text: '22. En mi área el trato entre las personas es respetuoso y amable, incluso cuando hay presión o carga de trabajo.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q23',
    text: '23. Es poco frecuente escuchar comentarios despectivos, burlas o chismes sobre otros dentro del área.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q24',
    text: '24. Cuando hay desacuerdos, se procura hablar directamente y con respeto, no a espaldas de la persona.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q25',
    text: '25. Las personas de mi área procuran ser amables y serviciales con otras áreas de la iglesia.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'select',
    id: 'q26',
    text: '26. Como director/a, cuido la forma en la que me comunico (tono, lenguaje, gestos) para que refleje amabilidad.',
    radio: true,
    options: singleSelectionOptions,
  },
  {
    type: 'textArea',
    id: 'q27',
    text: '27. ¿En qué ves que tu área ha crecido recientemente en el valor de AMABILIDAD?',
  },
  {
    type: 'textArea',
    id: 'q28',
    text: '28. ¿Qué cambios o prácticas consideras que ayudarían a que tu área viva aún más el valor de AMABILIDAD?',
  },

  // SECTION 5 – SÍNTESIS
  {
    type: 'title',
    text: 'SECCIÓN 5 – Síntesis general del área',
    class: 'section-title',
  },
  {
    type: 'textArea',
    id: 'q29',
    text: '29. Si tuvieras que escoger un valor (amor, presencia, excelencia, amabilidad) en el que tu área esté más fuerte hoy, ¿cuál sería y por qué?',
  },
  {
    type: 'textArea',
    id: 'q30',
    text: '30. Si tuvieras que escoger un valor en el que tu área necesita crecer con más urgencia, ¿cuál sería y por qué?',
  },
  {
    type: 'textArea',
    id: 'q31',
    text: '31. ¿Qué acciones concretas te propones como director/a para ayudar a tu área a crecer en estos valores durante los próximos 6–12 meses?',
  },
  {
    type: 'send',
    text: 'Enviar',
    class: 'send-button',
  },
];
